import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, Row, Col, Card, Flex, Table, Space, Grid } from 'antd';
import {
	XForm,
	XContainer,
	XSearch,
	XThemeContainer,
	XThemeFilterCards,
	XThemeInputText,
	XThemeFilterButton,
	XThemeTable,
} from '../../styles/GlobalThemeStyle';
import Header from '../../components/Header/Header';
import { getUsersApi, getUsersReset } from '../../actions/getUsersAction';
import {
	updateNotificationPermissionApi,
	updateNotificationPermissionReset,
} from '../../actions/updateNotificationPermission';
import moment from 'moment';
import { checkModulePermissions, urlPagination } from '../../utils/helper';
import {
	SearchButton,
	XInputText,
} from '../AnalyseCoverage/AnalyseCoverageStyle';
import HeaderFile from '../../components/Header/HeaderFile';
import { XTheme2InnerCard, XTheme2Para1 } from '../Dashboard/DashboardStyleCQ';
import {
	XTheme2Button,
	XTheme2InputText,
	XTheme2MainTitle,
	XTheme2Table,
} from '../../styles/GlobalThemeStyleCQ';

const NotificationManagement = (props) => {
	const {
		getUsers,
		getUsersState,
		getUsersReset,
		updateNotificationPermission,
		updateNotificationPermissionState,
		updateNotificationPermissionReset,
	} = props;
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const [tableData, setTableData] = useState([]);
	const [totalRecords, setTotalRecords] = useState('');
	const [loading, setLoading] = useState(false);
	const defaultFilters = {
		search: '',
		page: 1,
		patient_name: '',
		role: '',
		created_on: '',
		limit: 10,
	};
	const getFiltersFromUrl = () => {
		const urlParams = new URLSearchParams(window.location.search);
		const urlFilters = {};

		// Iterate through each query parameter and set it in the state
		for (const [key, value] of urlParams.entries()) {
			urlFilters[key] = value;
		}

		// Merge with default filters or initial state as needed
		const filters = {
			...defaultFilters, // Replace with your default filters
			...urlFilters,
		};

		return filters;
	};
	const initialFilters = getFiltersFromUrl();

	const [filters, setFilters] = useState(initialFilters);

	const columns = [
		{
			title: 'User Name',
			dataIndex: 'userName',
		},
		{
			title: 'Role',
			dataIndex: 'role',
		},
		{
			title: 'Organization',
			dataIndex: 'organization',
		},
		{
			title: 'Region',
			dataIndex: 'region',
		},
		{
			title: 'Hospital',
			dataIndex: 'hospital',
		},
		// {
		// 	title: 'Active',
		// 	dataIndex: 'is_active',
		// },
		{
			title: 'Joined On',
			dataIndex: 'createdAt',
			sorter: (a, b) => a.createdAt - b.createdAt,
			sortDirections: ['ascend', 'descend'],
		},
		// {
		// 	title: <div className="text-center">Action</div>,
		// 	dataIndex: 'action',
		// 	width: '10%',
		// },
	];

	const start = () => {
		setSelectedRowKeys([]);
	};

	const handleSubmit = () => {
		setLoading(true);
		updateNotificationPermission({ userIds: selectedRowKeys });
	};
	const onSelectChange = (newSelectedRowKeys) => {
		setSelectedRowKeys(newSelectedRowKeys);
	};

	const rowSelection = {
		selectedRowKeys,
		onChange: onSelectChange,
	};
	const hasSelected = selectedRowKeys.length > 0;

	useEffect(() => {
		getUsers({});
	}, []);

	useEffect(() => {
		if (getUsersState.apiState === 'success') {
			if (getUsersState.data.all_users.length > 0) {
				setTotalRecords(getUsersState.data.total_count);
				const updatedUsers = [];
				const selectedUsers = [];

				getUsersState.data.all_users.map((item, index) => {
					updatedUsers.push({
						key: item._id,
						_id: item._id,
						userName: item.name,
						name: item.name,
						// is_active: item.is_active ? (
						// 	<Tag color="green">Active</Tag>
						// ) : (
						// 	<Tag color="red">Suspended</Tag>
						// ),
						createdAt: moment(item.createdAt).format('DD-MM-YYYY'),
						role: item.role.display_name,
						organization: item.organization
							? item.organization
							: '-',
						region: item.region ? item.region : '-',
						hospital: item.hospital ? item.hospital : '-',
					});

					if (item.adminNotification) {
						selectedUsers.push(item._id);
					}
				});

				setSelectedRowKeys(selectedUsers);
				setTableData(updatedUsers);
				setLoading(false);
			} else {
				setTableData([]);
				setTotalRecords(0);
			}
			getUsersReset();
		}
	}, [getUsersState]);

	useEffect(() => {
		if (updateNotificationPermissionState.apiState === 'success') {
			getUsers({});
			updateNotificationPermissionReset();
		} else if (updateNotificationPermissionState.apiState === 'error') {
			updateNotificationPermissionReset();
		}
	}, [updateNotificationPermissionState]);

	useEffect(() => {
		// Retrieve filters from the updated URL
		const updatedFilters = getFiltersFromUrl();
		setFilters({ ...updatedFilters });

		// Make API call with updated filters and pagination
		checkModulePermissions('user-management').sub_modules.includes(
			'list-users',
		) && getUsers({ ...updatedFilters });
	}, [window.location.search]);

	const fetchCases = (pagination, _, sorter, ___) => {
		const queryParams = new URLSearchParams();

		// Append each filter to the query string
		Object.entries(filters).forEach(([key, value]) => {
			queryParams.append(key, value);
		});

		//Setting page filters: page size, sort, sort direction and limit in the query string
		queryParams.set(
			'page',
			pagination.current ? pagination.current : pagination,
		);
		queryParams.set('limit', pagination?.pageSize ?? 10);

		if (sorter && Object.keys(sorter).length > 0) {
			queryParams.set('sort', sorter ? sorter.field : 'createdAt');
			queryParams.set(
				'sortDirection',
				sorter ? sorter.order : filters.sortDirection,
			);
		} else {
			queryParams.set('sort', 'createdAt');
			queryParams.set('sortDirection', 'descend');
		}

		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
		window.history.pushState({}, '', newUrl);
		setFilters({
			...filters,
			sort: sorter ? sorter.field : 'createdAt',
			sortDirection: sorter ? sorter.order : 'descend',
			page: pagination.current ? pagination.current : pagination,
			limit: pagination.pageSize ? pagination.pageSize : 10,
		});
	};
	const { useBreakpoint } = Grid;
	const screens = useBreakpoint();
	const isMobile = !screens.md;
	return (
		<>
			<>
				{props.displayHeader ? (
					<></>
				) : (
					<>
						<Col lg={24} xl={24} xs={0} md={0}>
							<Header headerTag="Notifications Management" />
						</Col>
						<Col lg={0} xl={0} xs={24} md={24}>
							<HeaderFile headerTag="notificationsManagement" />
						</Col>
					</>
				)}

				<XThemeContainer fluid>
					<Row gutter={[15, 15]} className="align-items-center mb-4">
						<Col
							xs={24}
							sm={24}
							md={24}
							lg={12}
							xl={12}
							className="text-center text-md-start"
						>
							<XTheme2MainTitle className="mb-2">
								Notification Management
							</XTheme2MainTitle>
							<XTheme2Para1>
								Enable or disable notifications for users
							</XTheme2Para1>
						</Col>
					</Row>

					<XTheme2InnerCard
						className="mb-3"
						bodyStyle={{ padding: '20px 0px' }}
					>
						<div className="smallTopBottomPadding mb-3 px-md-4">
							<Row
								gutter={[15, 15]}
								className="align-items-center"
							>
								<Col xs={12} sm={12} md={6} lg={4}>
									<h1
										className="cardTitle mb-0"
										style={{ fontSize: '18px' }}
									>
										Total {totalRecords} Users
									</h1>
								</Col>
								<Col
									xs={24}
									sm={16}
									md={12}
									lg={12}
									className="d-none d-md-block"
								>
									<Space>
										<XTheme2InputText
											size="large"
											allowClear
											placeholder="Search for Users"
											defaultValue={
												filters.patient_name
													? filters.patient_name
													: null
											}
											onChange={(v) => {
												if (v.target.value === '') {
													urlPagination(
														filters,
														'patient_name',
														'',
													);
													setFilters({
														...filters,
														patient_name: '',
													});
												} else {
													setFilters({
														...filters,
														patient_name:
															v.target.value,
													});
												}
											}}
											onKeyDown={(e) => {
												if (e.key === 'Enter') {
													const searchValue =
														filters.patient_name
															? filters.patient_name
															: '';
													if (searchValue) {
														urlPagination(
															filters,
															'patient_name',
															searchValue,
														);
														setFilters({
															...filters,
															patient_name:
																searchValue,
														});
													}
												}
											}}
										/>
										<XTheme2Button
											size="large"
											onClick={() => {
												// Trigger search when the button is clicked
												const searchValue =
													filters.patient_name
														? filters.patient_name
														: '';
												if (searchValue) {
													urlPagination(
														filters,
														'patient_name',
														searchValue,
													);
													setFilters({
														...filters,
														patient_name:
															searchValue,
													});
												}
											}}
										>
											Search
										</XTheme2Button>
									</Space>
								</Col>
								<Col
									xs={12}
									sm={12}
									md={6}
									lg={8}
									className="text-end"
								>
									<Space>
										<XTheme2Button
											className="noBackground"
											size="large"
											onClick={start}
											disabled={!hasSelected}
										>
											Reset
										</XTheme2Button>
										{isMobile ? (
											<XTheme2Button
												size="large"
												onClick={handleSubmit}
												loading={loading}
											>
												Allow
											</XTheme2Button>
										) : (
											<XTheme2Button
												size="large"
												onClick={handleSubmit}
												loading={loading}
											>
												Allow Notifications
											</XTheme2Button>
										)}
									</Space>
								</Col>
							</Row>
						</div>
						<XTheme2Table
							rowSelection={rowSelection}
							columns={columns}
							loading={
								getUsersState.apiState === 'loading'
									? true
									: false
							}
							dataSource={tableData}
							pagination={{
								total: totalRecords,
								current: Number(filters.page),
								showSizeChanger: true,
								pageSize: filters.limit,
							}}
							scroll={{ x: 'max-content' }}
							onChange={fetchCases}
						/>
					</XTheme2InnerCard>
				</XThemeContainer>
			</>
		</>
	);
};

const mapStateToProps = (state) => ({
	getUsersState: state.getUsers,
	updateNotificationPermissionState: state.updateNotificationPermission,
});

const mapDispatchToProps = (dispatch) => ({
	getUsers: (params) => dispatch(getUsersApi(params)),
	getUsersReset: () => dispatch(getUsersReset()),
	updateNotificationPermission: (params) =>
		dispatch(updateNotificationPermissionApi(params)),
	updateNotificationPermissionReset: () =>
		dispatch(updateNotificationPermissionReset()),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(NotificationManagement);
